import { normalizeString } from 'src/utils/normalizeString'

interface ContextualFilter {
  categoria: string
  excludedTerms: string[]
  items: Array<{
    nome: string
    url: string
    imgUrl: string
  }>
}

const getNormalizedTerms = (terms: string[] = []) =>
  terms.map((item) => normalizeString(item.toLowerCase()))

export const getContextualFilter = (
  term: string,
  allFilters: ContextualFilter[]
) => {
  if (!term || !allFilters || allFilters.length === 0) {
    return null
  }

  const termStrip = normalizeString(term.toLocaleLowerCase())

  const contextualFilter = allFilters.find(({ categoria }) => {
    const normalizedCategory = normalizeString(categoria.toLowerCase())

    return termStrip.toLowerCase().includes(normalizedCategory)
  })

  if (!contextualFilter) {
    return null
  }

  const hasExcludedTerm = contextualFilter?.excludedTerms?.some(
    (excluded: string) =>
      termStrip.includes(normalizeString(excluded.toLowerCase()))
  )

  if (hasExcludedTerm) {
    return null
  }

  return contextualFilter
}

export const filterComponentsByTermAndExcludes = <T extends { data?: unknown }>(
  term: string,
  components: T[]
): T[] => {
  if (!term || !components || components.length === 0) {
    return []
  }

  const normalizedTerm = normalizeString(term.toLowerCase())

  return components.filter((component) => {
    const data = component.data as {
      term?: string[]
      searchTerms?: string[]
      excludedTerms?: string[]
    }

    const terms = data?.term?.length ? data.term : data?.searchTerms ?? []
    const normalizedTerms = getNormalizedTerms(terms)

    const hasMatchingTerm =
      normalizedTerms.length > 0 &&
      normalizedTerms.some((componentTerm) =>
        normalizedTerm.includes(componentTerm)
      )

    if (!hasMatchingTerm) {
      return false
    }

    const normalizedExcludedTerms = getNormalizedTerms(
      data?.excludedTerms ?? []
    )

    const hasExcludedTerm = normalizedExcludedTerms.some((excludedTerm) =>
      normalizedTerm.includes(excludedTerm)
    )

    return !hasExcludedTerm
  })
}
